import { Spin } from "antd";
import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { LoadingOutlined } from "@ant-design/icons";
import { baseUrl, CheckBaseUrlLive } from ".";

const NetworkDetector = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [onlineText, setOnlineText] = useState("Network connection lost");
  const [loader, setLoader] = useState(false);
  const [textColor, setTextColor] = useState(false);

  const ur_l = CheckBaseUrlLive(baseUrl);

  useEffect(() => {
    const handleOnline = () => {
      setOnlineText("Connected to network...");
      setTextColor(true);
      setLoader(true);
      const timer = setTimeout(() => {
        setLoader(false);
        setIsOnline(true);
      }, 3000);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setTextColor(false);
      setOnlineText("Network connection lost");
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return (
    <div>
      {!isOnline && ur_l && (
        <>
          <Modal
            className="rounded "
            show={true}
            backdrop="static"
            size="md"
            centered
          >
            <Modal.Body className="p-5">
              <Spin indicator={<LoadingOutlined spin />} spinning={loader}>
                <h5
                  className={`text-center ${textColor ? "text-success" : "text-danger"}`}
                >
                  {textColor ? (
                    <i class="fa-solid fa-wifi me-2"></i>
                  ) : (
                    <i class="fa-solid fa-triangle-exclamation me-2"></i>
                  )}
                  {onlineText}
                </h5>
                <p className="mt-3 text-center">
                  You're offline. Some features may be unavailable until
                  connection is restored.
                </p>
                <h4 className="mt-2 text-center text-danger"></h4>
              </Spin>
            </Modal.Body>
          </Modal>
        </>
      )}
    </div>
  );
};

export default NetworkDetector;
